<template>
    <div class="cz2__steps-options__confirm">
        <div class="cz2__steps-options__confirm-gradient">
            <img
                src="../assets/images/pop-yourself-logo.svg"
                alt="Pop! Yourself Logo"
                class="cz2__steps-options__contact__logo"
            >

            <div
                class="cz2__sb-logo-k-two-pack"
            />

            <div
                ref="rendererPlaceholder"
                class="cz2__renderer-placeholder"
            />
        </div>

        <div class="cz2__confirmation-wrapper">
            <div class="cz2__steps-options__title">
                {{$t('STEP_CONFIRM')}}
            </div>

            <div class="cz2__confirmation__next">
                <div v-html="$t('WHATS_NEXT')" />
            </div>

            <sb-button
                v-if="isSpellingBee"
                primary
                class="cz2__confirm-exit"
                @click="restart"
                variant="tertiary"
                heightVariant="large"
            >
                {{$t('MAKE_ANOTHER')}}
            </sb-button>
            <btn
                v-else
                primary
                class="cz2__confirm-exit"
                @click="restart"
            >
                {{$t('ACTION_EXIT')}}
            </btn>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options__confirm {
            pointer-events: auto;

            width: 100%;
            height: 100%;
            @include bg(gradientBlue);

            display: flex;
            flex-direction: column;

            .cz2__renderer-placeholder {
                margin-top: 160px;

                width: 100%;
                height: 100%;
            }
        }

        .cz2__steps-options__confirm-gradient {
            width: 100%;
            height: 60%;
            background: linear-gradient(180deg, rgba(2,122,230,1) 0%, rgba(2,122,230,1) 75%, rgba(2,122,230,1) 80%, rgba(2,122,230,0) 90%);
        }

        .cz2__confirmation-wrapper {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .cz2__steps-options__title {
                margin-top: -100px;
                margin-bottom: 8px;

                @include font(h1);

                color: #fff;
                font-size: 54px;
                line-height: 54px;
            }

            .cz2__confirmation__next {
                margin-bottom: 47px;

                width: 820px;

                @include font(bodyRegular);
                text-transform: none;
                font-size: 24px;
                line-height: 28px;
                text-align: center;
                color: color(primaryWhite);
            }

            .cz2__btn.cz2__confirm-exit {
                min-width: 240px;
            }
        }
    }

    #cz2.cz2.cz2__is-sb.cz2__is-confirm-step.cz2__is-kiosk {
        .cz2__sb-funko-logo {
            display: none;
        }

        .cz2__steps-options__confirm {
            @include bg(transparent);
        }

        .cz2__steps-options__title {
            font-family: 'BluuNext-Bold';
            font-size: 80px;
            text-transform: none;
            padding-bottom: 48px;
        }

        .cz2__confirmation__next, .cz2__steps-options__title {
            color: #000;
            z-index: 1;
        }

        .cz2__confirmation__next {
            font-size: 38px;
            line-height: 44px;
            padding-bottom: 48px;
        }

        .cz2__sb-border_3-wrapper {
            background-image: none;
            height: 100%;

            .cz2__sb-border_3 {
                height: 100%;
            }
        }

        .cz2__steps-options__confirm-gradient {
            background: transparent;
        }

        .cz2__confirm-exit {
            width: 350px;
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';
    import SbButton from './SbButton.vue';

    export default {
        components: {
            Btn,
            SbButton,
        },

        mounted() {
            this.updateNavigation();

            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'confirm',
                placeholder: this.$refs.rendererPlaceholder,
            });
        },

        beforeDestroy() {
            this.emitter.$emit('setRendererPlaceholder', {
                owner: 'confirm',
            });
        },

        computed: {
            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },
        },

        methods: {
            updateNavigation() {
                this.$emit('updateNavigation', {
                    hasBack: false,
                    canGoBack: false,
                    hasNext: true,
                    canGoNext: true,
                    nextSpecial: 'Reset',
                });
            },

            restart() {
                window.location.reload();

                // this.$store.dispatch('resetCustomizations');
                // this.$store.dispatch('selectStep', 'splash');
            },
        },
    };
</script>
